import React from 'react';
import { useAdmin } from '../../../base/AdminContext';
import AdminProtectedRoute from '../../components/admin/AdminProtectedRoute';
import AdminLayout from '../../components/admin/AdminLayout';

const AdminDashboardPage: React.FC = () => {
    const { admin, permissions } = useAdmin();

    const statsCards = [
        {
            title: 'Tổng chuyến đi',
            value: '1,234',
            icon: 'fas fa-route',
            color: 'primary',
            change: '+12%',
            changeType: 'increase'
        },
        {
            title: 'Tài xế hoạt động',
            value: '56',
            icon: 'fas fa-users',
            color: 'success',
            change: '+5%',
            changeType: 'increase'
        },
        {
            title: 'Người dùng',
            value: '789',
            icon: 'fas fa-user-friends',
            color: 'info',
            change: '+8%',
            changeType: 'increase'
        },
        {
            title: 'Doanh thu tháng',
            value: '125M',
            icon: 'fas fa-money-bill-wave',
            color: 'warning',
            change: '-2%',
            changeType: 'decrease'
        }
    ];

    return (
        <AdminProtectedRoute requiredModule="dashboard">
            <AdminLayout>
                <div className="p-4">
                    {/* Page Title */}
                    <div className="flex align-items-center justify-content-between mb-4">
                        <h1 className="text-3xl font-bold text-900 m-0">
                            <i className="pi pi-home mr-3"></i>
                            Dashboard
                        </h1>
                        <div className="text-600">
                            Chào mừng trở lại, <strong className="text-900">{admin?.full_name}</strong>!
                        </div>
                    </div>

                    {/* Stats Cards */}
                    <div className="row mb-4">
                        {statsCards.map((card, index) => (
                            <div key={index} className="col-xl-3 col-md-6 mb-4">
                                <div className={`card border-left-${card.color} shadow h-100 py-2`}>
                                    <div className="card-body">
                                        <div className="row no-gutters align-items-center">
                                            <div className="col mr-2">
                                                <div className={`text-xs font-weight-bold text-${card.color} text-uppercase mb-1`}>
                                                    {card.title}
                                                </div>
                                                <div className="h5 mb-0 font-weight-bold text-gray-800">
                                                    {card.value}
                                                </div>
                                                <div className={`text-xs mt-1 ${card.changeType === 'increase' ? 'text-success' : 'text-danger'}`}>
                                                    <i className={`fas ${card.changeType === 'increase' ? 'fa-arrow-up' : 'fa-arrow-down'} me-1`}></i>
                                                    {card.change} so với tháng trước
                                                </div>
                                            </div>
                                            <div className="col-auto">
                                                <i className={`${card.icon} fa-2x text-gray-300`}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Charts and Recent Activity */}
                    <div className="row">
                        {/* Chart */}
                        <div className="col-xl-8 col-lg-7">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 className="m-0 font-weight-bold text-primary">
                                        <i className="fas fa-chart-area me-2"></i>
                                        Thống kê chuyến đi
                                    </h6>
                                    <div className="dropdown no-arrow">
                                        <a className="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i className="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-right shadow animated--fade-in" aria-labelledby="dropdownMenuLink">
                                            <div className="dropdown-header">Tùy chọn:</div>
                                            <a className="dropdown-item" href="#">7 ngày qua</a>
                                            <a className="dropdown-item" href="#">30 ngày qua</a>
                                            <a className="dropdown-item" href="#">3 tháng qua</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="chart-area">
                                        <div className="d-flex align-items-center justify-content-center" style={{ height: '300px', background: '#f8f9fa', borderRadius: '8px' }}>
                                            <div className="text-center">
                                                <i className="fas fa-chart-line fa-3x text-muted mb-3"></i>
                                                <p className="text-muted">Biểu đồ thống kê sẽ được hiển thị tại đây</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Recent Activity */}
                        <div className="col-xl-4 col-lg-5">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">
                                        <i className="fas fa-clock me-2"></i>
                                        Hoạt động gần đây
                                    </h6>
                                </div>
                                <div className="card-body">
                                    <div className="timeline">
                                        <div className="timeline-item">
                                            <div className="timeline-marker bg-primary"></div>
                                            <div className="timeline-content">
                                                <h6 className="mb-1">Chuyến đi mới</h6>
                                                <p className="text-muted small mb-1">Từ Hà Nội đến Hải Phòng</p>
                                                <small className="text-muted">5 phút trước</small>
                                            </div>
                                        </div>
                                        <div className="timeline-item">
                                            <div className="timeline-marker bg-success"></div>
                                            <div className="timeline-content">
                                                <h6 className="mb-1">Tài xế được duyệt</h6>
                                                <p className="text-muted small mb-1">Nguyễn Văn A</p>
                                                <small className="text-muted">15 phút trước</small>
                                            </div>
                                        </div>
                                        <div className="timeline-item">
                                            <div className="timeline-marker bg-info"></div>
                                            <div className="timeline-content">
                                                <h6 className="mb-1">Người dùng mới</h6>
                                                <p className="text-muted small mb-1">user@example.com</p>
                                                <small className="text-muted">30 phút trước</small>
                                            </div>
                                        </div>
                                        <div className="timeline-item">
                                            <div className="timeline-marker bg-warning"></div>
                                            <div className="timeline-content">
                                                <h6 className="mb-1">Chuyến đi bị hủy</h6>
                                                <p className="text-muted small mb-1">Lý do: Thời tiết xấu</p>
                                                <small className="text-muted">1 giờ trước</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Quick Actions */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">
                                        <i className="fas fa-bolt me-2"></i>
                                        Thao tác nhanh
                                    </h6>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <button className="btn btn-outline-primary w-100 py-3">
                                                <i className="fas fa-plus-circle fa-2x mb-2"></i>
                                                <br />
                                                Thêm tài xế mới
                                            </button>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <button className="btn btn-outline-success w-100 py-3">
                                                <i className="fas fa-ticket-alt fa-2x mb-2"></i>
                                                <br />
                                                Tạo voucher
                                            </button>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <button className="btn btn-outline-info w-100 py-3">
                                                <i className="fas fa-bell fa-2x mb-2"></i>
                                                <br />
                                                Gửi thông báo
                                            </button>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <button className="btn btn-outline-warning w-100 py-3">
                                                <i className="fas fa-cog fa-2x mb-2"></i>
                                                <br />
                                                Cài đặt hệ thống
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Permission Summary */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">
                                        <i className="fas fa-user-shield me-2"></i>
                                        Quyền của bạn
                                    </h6>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        {Object.entries(
                                            permissions.reduce((acc, perm) => {
                                                if (!acc[perm.module_name]) {
                                                    acc[perm.module_name] = [];
                                                }
                                                acc[perm.module_name].push(perm);
                                                return acc;
                                            }, {} as Record<string, typeof permissions>)
                                        ).map(([moduleName, modulePerms]) => (
                                            <div key={moduleName} className="col-lg-4 col-md-6 mb-3">
                                                <div className="card border-left-success">
                                                    <div className="card-body">
                                                        <h6 className="font-weight-bold text-primary">{moduleName}</h6>
                                                        <div className="small">
                                                            {modulePerms.map((perm, idx) => (
                                                                <div key={idx} className="mb-1">
                                                                    <strong>{perm.sub_module_name || 'Chính'}</strong>
                                                                    <div className="d-flex gap-2 flex-wrap">
                                                                        {perm.view_permission && <span className="badge bg-primary">Xem</span>}
                                                                        {perm.add_permission && <span className="badge bg-success">Thêm</span>}
                                                                        {perm.edit_permission && <span className="badge bg-warning">Sửa</span>}
                                                                        {perm.delete_permission && <span className="badge bg-danger">Xóa</span>}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminLayout>
        </AdminProtectedRoute>
    );
};

export default AdminDashboardPage;
